import {makeStyles} from 'external/material'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    paddingBottom: 20,
    flexDirection: 'column',
    '& .label' : {
      color: '#69738c',
      fontWeight: 'bold',
      marginBottom: 8
    }
  },
  premise: {
    marginTop: 25,
  },
  answer: {
    marginTop: 35,
  }
}))

export {useStyles as default}
